import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import carConfigurationSelectors from '../../../../../store/selectors/carConfigurationSelectors';
import SpecificationsAndFeatures from './SpecificationsAndFeatures';
import { customiseActions } from '../../../../../store/reducers/customiseReducer';
import OverlayLoader from '../../../../presentational/loaders/OverlayLoader';
import SectionLoader from '../../../../../../common/components/loaders/SectionLoader';
import currentDealSelectors from '../../../../../store/selectors/currentDealSelectors';
import useWidgetContext from '../../../../../../common/react/useWidgetContext';
import urlUtilities from '../../../../../../../../common/utilities/urlUtilities';
import stringUtilities from '../../../../../../../../common/utilities/stringUtilities';

const SpecificationsAndFeaturesContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const {
    configuration: { specificationsBrochureUrl },
  } = useWidgetContext();
  const isConfigurationLoading = useSelector(currentDealSelectors.getLoadingStatus);
  const keyFeatures = useSelector(carConfigurationSelectors.getConfigurationKeyFeatures);
  const engineTitle = useSelector(carConfigurationSelectors.getConfigurationEngineTitle);
  const transmissionTitle = useSelector(carConfigurationSelectors.getConfigurationTransmissionTitle);
  const modelTitle = useSelector(carConfigurationSelectors.getConfigurationModelTitle);
  const brochureUrlWithModel = urlUtilities.replaceUrlParamWildcard(
    specificationsBrochureUrl,
    'model',
    stringUtilities.slugify(modelTitle),
  );

  const openModal = useCallback(() => {
    dispatch(customiseActions.setSpecificationsFeaturesModal(true));
  }, []);

  if (!keyFeatures) {
    return <SectionLoader />;
  }

  return (
    // This loader behaviour is for preventing page size flickering,
    // since options changes also recall car details endpoint.
    <OverlayLoader loading={isConfigurationLoading} width={'100%'}>
      <SpecificationsAndFeatures
        keyFeatures={keyFeatures}
        engineTitle={engineTitle}
        transmissionTitle={transmissionTitle}
        openModal={openModal}
        brochureUrl={brochureUrlWithModel}
      />
    </OverlayLoader>
  );
};

export default SpecificationsAndFeaturesContainer;
